export default __webpack_public_path__ + "static/media/rocket.8d35fb76.webp";